var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99829 0C2.17595 0 0.694336 1.48162 0.694336 3.30396V19.8237C0.694336 21.6461 2.17595 23.1277 3.99829 23.1277H20.5181C22.3404 23.1277 23.822 21.6461 23.822 19.8237V3.30396C23.822 1.48162 22.3404 0 20.5181 0H3.99829ZM19.3359 4.33645L13.9773 10.4591L20.2806 18.7913H15.3453L11.4838 13.7372L7.05962 18.7913H4.60746L10.3378 12.2401L4.29255 4.33645H9.35174L12.8467 8.95682L16.8837 4.33645H19.3359ZM17.3845 17.3251L8.61351 5.72514H7.15254L16.0216 17.3251H17.3793H17.3845Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.d0c7f80e55877784a53276387ed70f72.svg";
export { ForwardRef as ReactComponent };